var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9372 11.0089L8.6927 7.86258C9.37273 7.048 9.78008 6.01055 9.78008 4.88084C9.78008 2.26181 7.59073 0.138672 4.89004 0.138672C2.18935 0.138672 0 2.26181 0 4.88084C0 7.49987 2.18935 9.62302 4.89004 9.62302C6.05497 9.62302 7.12477 9.22799 7.96475 8.56852L11.2092 11.7149C11.4108 11.9104 11.7371 11.9107 11.9381 11.7158C12.1405 11.5195 12.1387 11.2044 11.9372 11.0089ZM8.74956 4.8804C8.74956 6.94806 7.02112 8.62423 4.889 8.62423C2.75687 8.62423 1.02844 6.94806 1.02844 4.8804C1.02844 2.81275 2.75687 1.13658 4.889 1.13658C7.02112 1.13658 8.74956 2.81275 8.74956 4.8804Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d74675ae.svg";
export { ForwardRef as ReactComponent };